import { type FC } from "react";

import { Button, Checkbox } from "@snapchat/snap-design-system";

import { LensSpaceLensFilterStatuses } from "../../../../core/pagination/models";
import { Flexbox } from "../../../../shared/components";
import { useLensFilterByStatus } from "../../../hooks";

import { LensFilterItem } from "./LensFilterItem";
import { StatusName, lensFilterItemContainer, separator, widthName } from "./LensFilterItem.styles";
import { lensFilterOptionsContainer } from "./LensFilterOptions.styles";

interface LensFilterOptions {
    onApplyFilters: () => void;
}

export const LensFilterOptions: FC<LensFilterOptions> = ({ onApplyFilters }) => {
    const { selectedAll, toggleAllSelected } = useLensFilterByStatus();

    return (
        <Flexbox flexDirection="column" className={lensFilterOptionsContainer}>
            <Flexbox
                alignItems="center"
                justifyContent="space-between"
                className={lensFilterItemContainer}
                onClick={toggleAllSelected}
            >
                <Checkbox value={selectedAll} />
                <Flexbox alignItems="center" className={widthName}>
                    <StatusName>All</StatusName>
                </Flexbox>
            </Flexbox>
            {Object.entries(LensSpaceLensFilterStatuses).map(([key, value]) => (
                <LensFilterItem key={key} value={value} />
            ))}
            <hr className={separator} />
            <Button onClick={onApplyFilters} data-testid="filter-status-apply">
                Apply
            </Button>
        </Flexbox>
    );
};
